import styled, { css } from 'styled-components';
import { Colors } from '../../colors';
export const Container = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;

  ${({ marginTop }) => marginTop &&
    css `
      margin-top: ${marginTop};
    `};

  ${({ marginBottom }) => marginBottom &&
    css `
      margin-bottom: ${marginBottom};
    `};
`;
export const Divider = styled.div `
  flex: 1;
  height: 1px;

  background: ${Colors.GS400};
`;
export const Label = styled.div `
  padding: 0 12px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: 0.14px;
  color: ${Colors.GS600};
`;
